var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('HeroHeader'),_vm._v(" "),_c('div',{staticClass:"text-scroll animated animated-delay-3",attrs:{"id":"text-scroll"}},[_c('div',{staticClass:"text-scroll-inner"},[_c('sendyInlineKickstarter')],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2554c8b1","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Home/Kickstarter.vue
// module id = null
// module chunks = 